import { ModalWrapper } from '../modal-wrapper'
import useStyles from './styles'

interface IProps {
  open: boolean
  handleClose: () => void
  src?: string | null
  alt: string
}

export const ImagePreview = ({ open, handleClose, src, alt }: IProps) => {
  const classes = useStyles({})

  if (!src) return null

  return (
    <ModalWrapper withoutX open={open} onClose={handleClose} className={classes.previewWrapper}>
      <img
        onClick={(e) => {
          e.stopPropagation()
        }}
        src={src}
        alt={alt}
        className={classes.imagePreview}
        loading="lazy"
      />
    </ModalWrapper>
  )
}
